import { render, staticRenderFns } from "./Verifactu.vue?vue&type=template&id=4c4576c9&scoped=true"
import script from "./Verifactu.vue?vue&type=script&lang=js"
export * from "./Verifactu.vue?vue&type=script&lang=js"
import style0 from "./Verifactu.vue?vue&type=style&index=0&id=4c4576c9&prod&scoped=true&lang=css"
import style1 from "./Verifactu.vue?vue&type=style&index=1&id=4c4576c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4576c9",
  null
  
)

export default component.exports